module.exports = __webpack_public_path__ + "img/deco-10.b44a8db0.png";